import ErrorBoundary from '@/src/components/ErrorBoundary';
import AppProvider from '@/src/providers/AppProvider';
import { useStore } from '@/src/redux/store';
import GlobalStyleSheet from '@/src/styles/globalStyleSheet';
import { isIOS } from '@/src/utils/userAgent';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { FenixProvidersDynamic } from '@/src/providers/FenixProvider';
import themeCustom from '../theme';

const Error = dynamic(() => import('../components/Error'));

function handleOnErrorTranslations() {
  // Avoid missmatch for SSR in local
}

function App({ Component, pageProps }) {
  const { initialState, i18n: { locale, messages } = {} } = pageProps;

  const store = useStore(initialState);

  const theme = useMemo(
    () => ({
      ...themeCustom,
    }),
    [],
  );

  const { isRevamp, fenixVersion } = initialState || {};

  return (
    <>
      <Head>
        <title>Promociones, descuentos y ofertas en Delivery - PedidosYa</title>
        <meta
          name="viewport"
          content="viewport-fit=cover, width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta name="theme-color" content="#fa0050" />
      </Head>
      <IntlProvider
        locale={locale}
        key={locale}
        defaultLocale="es"
        textComponent="span"
        messages={messages}
        onError={handleOnErrorTranslations}
      >
        <Provider store={store}>
          <FenixProvidersDynamic
            isRevamp={isRevamp}
            customTheme={theme}
            fenixVersion={fenixVersion}
          >
            <AppProvider initialState={initialState}>
              <GlobalStyleSheet
                origin={initialState?.origin}
                isios={isIOS(initialState?.shared?.platform)} //  Importante para manejar espaciado en iphones safe area navbar etiqueta header
                isDesktop={initialState?.shared?.platform === 'desktop'}
                isRevamp={isRevamp}
              />
              <ErrorBoundary fallback={<Error />}>
                <Component {...pageProps} />
              </ErrorBoundary>
            </AppProvider>
          </FenixProvidersDynamic>
        </Provider>
      </IntlProvider>
    </>
  );
}

App.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.shape({
    initialState: PropTypes.shape({}),
    fwfConfig: PropTypes.shape({}),
    trackerConfig: PropTypes.shape({}),
    i18n: PropTypes.shape({
      locale: PropTypes.string,
      messages: PropTypes.shape({}),
    }),
  }),
};

App.defaultProps = {
  pageProps: {},
};

export default App;
